import type { ReactNode } from 'react';

export function BottomSheet({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`rounded-t-3xl bg-ink-2/95 px-4 pt-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl ring-1 ring-white/10 backdrop-blur ${className}`}
    >
      {children}
    </div>
  );
}
